/**
 * E-sign checkout completion handler
 *
 * After signature verification, submits the cart to create a Stripe checkout session
 * and redirects to the checkout URL.
 *
 * Reads config from data attributes on the container element:
 *   data-document-id - The esign document ID
 *   data-signer-email - The signer's email address
 */

(function() {
  var container = document.getElementById('esign-checkout');
  if (!container) return;

  var documentId = container.dataset.documentId;
  var signerEmail = container.dataset.signerEmail;

  // Read cart items from localStorage
  var cartData = JSON.parse(localStorage.getItem('cart') || '{"items":[]}');

  if (!cartData.items || cartData.items.length === 0) {
    alert('Your cart is empty. Please add items before checking out.');
    window.location.href = '/app/shop/cart';
    return;
  }

  var payload = {
    items: cartData.items.map(function(item) {
      return { productId: item.productId, quantity: item.quantity };
    }),
    metadata: { esign_document_id: parseInt(documentId, 10) },
    customerEmail: signerEmail,
  };

  fetch('/api/shop/checkout', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  })
  .then(function(response) { return response.json().then(function(data) { return { ok: response.ok, data: data }; }); })
  .then(function(result) {
    if (!result.ok || !result.data.checkoutUrl) {
      alert(result.data.message || 'Checkout failed. Please try again.');
      window.location.href = '/app/shop/cart';
      return;
    }

    localStorage.removeItem('cart');
    window.location.href = result.data.checkoutUrl;
  })
  .catch(function() {
    alert('Checkout failed. Please try again.');
    window.location.href = '/app/shop/cart';
  });
})();
